module.exports = __webpack_public_path__ + "static/media/zoom.dea9f266.svg";